import Vue from 'vue';
import Router from 'vue-router';
import VueCookies from 'vue-cookies';
import VueGtag from "vue-gtag";
import VueMeta from 'vue-meta';
import Vuex from 'vuex';

import App from '@/App.vue'

import { routes } from './routes.js';
import { store } from './store/store.js';

Vue.config.productionTip = false;

Vue.use(Router);
Vue.use(VueCookies);
Vue.use(VueMeta);
Vue.use(Vuex);

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$api = 'http://localhost:8080/api';
} else {
  Vue.prototype.$api = 'https://api.rebar.ai';
}


/**
 * Vue Router Definition
 */
const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});


/**
 * Vue Google Tag Analytics Definition
 */
Vue.use(VueGtag, {
  config: { id: 'UA-145826076-2' }
}, router);


/**
 * Vuex Data Store Definition
 */
const vuexStore = new Vuex.Store(store)


/**
 * Vue
 */
new Vue({
  render: h => h(App),
  router: router,
  store: vuexStore
}).$mount('#app');